/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import {
  useColorModeValue,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Icon,
  Text,
  Button,
} from '@chakra-ui/react';
import { BsFileEarmarkPlus } from 'react-icons/bs';
import { MdOutlineOpenInNew } from 'react-icons/md';
import { FieldValues, UseFormRegister } from 'react-hook-form';

interface FileInputFormProps {
  defaultVal?: any;
  name: string | undefined | any;
  label: string | undefined;
  isRequired?: boolean;
  register: UseFormRegister<FieldValues>;
  watch: any;
  errors: any;
}

export const FileInputForm = ({
  defaultVal,
  name,
  label,
  isRequired,
  register,
  watch,
  errors,
}: FileInputFormProps) => {
  const [preview, setPreview] = useState<any>(undefined);

  useEffect(() => {
    if (watch(name)?.length > 0 && typeof watch(name) === 'object') {
      setPreview(watch(name)[0]);
    } else {
      setPreview(undefined);
    }
  }, [watch(name)]);

  return (
    <FormControl isRequired={isRequired} isInvalid={!!errors[name]} mb={5}>
      <FormLabel fontWeight="bold" mb={2} htmlFor={name}>
        {label}
      </FormLabel>
      {preview ? (
        <Text mb="10px">{preview?.name}</Text>
      ) : defaultVal ? (
        <Button
          mb="10px"
          variant="solid"
          w="250px"
          colorScheme="button.primary"
          leftIcon={<MdOutlineOpenInNew size="1.3em" />}
          onClick={() => window.open(defaultVal, '_blank')}
          _hover={{ opacity: 0.5 }}
          textTransform="uppercase"
          boxShadow="0px 3px 6px #00000065"
        >
          Ver arquivo enviado
        </Button>
      ) : null}
      <label htmlFor={name} style={{ display: 'block', width: '200px' }}>
        <Flex
          w="250px"
          h="40px"
          borderRadius="5px"
          border={errors[name] ? '2px solid red' : ''}
          textTransform="uppercase"
          bg={useColorModeValue('theme.light.bodyInput', 'theme.dark.bodyInput')}
          cursor="pointer"
          align="center"
          justify="center"
          _hover={{ opacity: 0.5 }}
          boxShadow="0px 3px 6px #00000065"
        >
          <Icon as={BsFileEarmarkPlus} mr="5px" fontSize="20px" />
          <Text fontWeight="bold">Selecionar arquivo</Text>
        </Flex>
      </label>
      <input
        id={name}
        type="file"
        hidden
        accept="image/png, image/jpeg, image/jpg, audio/mp3, video/mp4, application/pdf"
        {...register(name)}
      />
      {errors[name] && <FormErrorMessage>{errors[name]?.message}</FormErrorMessage>}
    </FormControl>
  );
};
